/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface ProjectPersonOtherDTO
 */
export interface ProjectPersonOtherDTO  {
    /**
     * 
     * @type {number}
     * @memberof ProjectPersonOtherDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectPersonOtherDTO
     */
    givenname?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectPersonOtherDTO
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectPersonOtherDTO
     */
    role?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectPersonOtherDTO
     */
    sequence?: number;
}

/**
 * Check if a given object implements the ProjectPersonOtherDTO interface.
 */
export function instanceOfProjectPersonOtherDTO(value: object): value is ProjectPersonOtherDTO {
    return true;
}

export function ProjectPersonOtherDTOFromJSON(json: any): ProjectPersonOtherDTO {
    return ProjectPersonOtherDTOFromJSONTyped(json, false);
}

export function ProjectPersonOtherDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectPersonOtherDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'givenname': json['givenname'] == null ? undefined : json['givenname'],
                  'surname': json['surname'] == null ? undefined : json['surname'],
                  'role': json['role'] == null ? undefined : json['role'],
                  'sequence': json['sequence'] == null ? undefined : json['sequence'],
    };
}

export function ProjectPersonOtherDTOToJSON(json: any): ProjectPersonOtherDTO {
    return ProjectPersonOtherDTOToJSONTyped(json, false);
}

export function ProjectPersonOtherDTOToJSONTyped(value?: ProjectPersonOtherDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'givenname': value['givenname'],
        'surname': value['surname'],
        'role': value['role'],
        'sequence': value['sequence'],
    };
}


